"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addShadows = void 0;
var diveTileData_1 = require("../../tilemap/diveTileData");
var diveTilemap_sidecar_1 = require("../../tilemap/diveTilemap-sidecar");
function addShadows() {
    var _a, sizeX, sizeY, j, i, gs, spacing, lessSpacing, gsT;
    return __generator(this, function (_b) {
        _a = __read(diveTilemap_sidecar_1.diveTilemap.getSize(), 2), sizeX = _a[0], sizeY = _a[1];
        // Add shadows
        for (j = 0; j < sizeY; j++) {
            for (i = 0; i < sizeX; i++) {
                gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
                spacing = 4;
                lessSpacing = spacing - 1;
                gsT = diveTilemap_sidecar_1.diveTilemap.getSafe(i, j - 1);
                if (gsT && gsT.tile1.type === diveTileData_1.EDiveTile.Wall) {
                    if (gs.tile1.type === diveTileData_1.EDiveTile.Wall) {
                    }
                    else {
                        if (gs.tile1.type === diveTileData_1.EDiveTile.Floor) {
                            gs.shadow = 2;
                        }
                        else {
                            gs.shadow = 1;
                        }
                    }
                }
            }
        }
        return [2 /*return*/];
    });
}
exports.addShadows = addShadows;
